<script setup lang="ts">
  import type { UseIntersectionObserverOptions } from '@vueuse/core';

  const props = defineProps({
    options: {
      type: Object as PropType<UseIntersectionObserverOptions>,
      default: undefined,
    },
  });

  //TODO: check if observer works as intended
  const emit = defineEmits(['appear', 'disappear', 'update']);

  const target = ref<HTMLElement | null>(null);

  const { stop } = useIntersectionObserver(
    target,
    ([entry]) => {
      if (entry.isIntersecting) {
        emit('appear');
      } else {
        emit('disappear');
      }
    },
    props.options,
  );

  onBeforeUnmount(() => {
    stop();
  });
</script>

<template>
  <div ref="target">
    <slot />
  </div>
</template>
